import { render, staticRenderFns } from "./testMap.vue?vue&type=template&id=37bf1d3c&scoped=true&"
import script from "./testMap.vue?vue&type=script&lang=js&"
export * from "./testMap.vue?vue&type=script&lang=js&"
import style0 from "./testMap.vue?vue&type=style&index=0&id=37bf1d3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bf1d3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37bf1d3c')) {
      api.createRecord('37bf1d3c', component.options)
    } else {
      api.reload('37bf1d3c', component.options)
    }
    module.hot.accept("./testMap.vue?vue&type=template&id=37bf1d3c&scoped=true&", function () {
      api.rerender('37bf1d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/service/testMap.vue"
export default component.exports